export const colorSchemes = {
    colorful: [
        '#EAC435', '#345995', '#03CEA4', '#FF6B6B', '#CA1551',
        '#3A3335', '#FFE19C', '#C1FFF2', '#511730', '#8789C0' ],
    cool: [
        '#5680E9', '#84CEEB', '#5AB9EA', '#C1C8E4', '#8860D0',
        '#7555E8', '#69C6EA', '#5971EA', '#AAACE2', '#C060D1' ],
    warm: [
        '#BA9434', '#FFE899', '#FFAC47', '#FF813D', '#E55730',
        '#BA9948', '#A38B3C', '#A36E2E', '#A35327', '#92381F'
    ]
};
